/* =============================================
   ROUTINE BUILDER – Main Logic v4
   Cart drawer opens on add, visual polish
   ============================================= */
(function() {
  'use strict';

  var DB = window.RoutineProductsDB || [];
  var STEPS = window.RoutineSteps || [];

  var state = {
    phase: 'quiz',
    skinType: null,
    priorities: [],
    gender: null,
    currentStep: 0,
    addedHandles: [],
    variantMap: {}
  };

  var $container, $hero, $quizWrap, $stepsWrap, $tabs, $stepFooter, $stickyCheckout;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    $container = document.getElementById('routine-builder');
    if (!$container) return;
    $hero = $container.querySelector('.rb-hero');
    $quizWrap = $container.querySelector('.rb-quiz');
    $stepsWrap = $container.querySelector('.rb-steps-container');
    $tabs = $container.querySelector('.rb-step-tabs');
    $stepFooter = $container.querySelector('.rb-step-footer');
    $stickyCheckout = $container.querySelector('.rb-sticky-checkout');

    renderQuiz();
    fetchAllVariants();
    hideZipchat();
    watchCartDrawer();
  }

  function hideZipchat() {
    var s = document.createElement('style');
    s.textContent = '[id*="zipchat"],[class*="zipchat"]{display:none!important;visibility:hidden!important;}';
    document.head.appendChild(s);
    setTimeout(function() {
      document.querySelectorAll('[id*="zipchat"],[class*="zipchat"]').forEach(function(el) {
        el.style.display = 'none';
      });
    }, 3000);
  }

  function fetchAllVariants() {
    var seen = {};
    DB.forEach(function(p) {
      if (seen[p.handle]) return;
      seen[p.handle] = true;
      fetch('/products/' + p.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d && d.variants && d.variants.length) {
            state.variantMap[p.handle] = d.variants[0].id;
          }
        }).catch(function() {});
    });
  }

  /* ---- QUIZ ---- */
  var quizQuestions = [
    {
      title: "Qual è il tuo tipo di pelle?",
      subtitle: "Scegli quello che ti rappresenta di più",
      type: "single",
      options: [
        { icon: "🌵", text: "Secca", value: "secca" },
        { icon: "✨", text: "Mista / Grassa", value: "mista-grassa" },
        { icon: "🌸", text: "Delicata / Sensibile", value: "delicata" },
        { icon: "❓", text: "Non lo so", value: "tutti" }
      ]
    },
    {
      title: "Quali sono le tue priorità?",
      subtitle: "Puoi sceglierne più di una",
      type: "multi",
      options: [
        { icon: "💧", text: "Idratazione", value: "idratazione" },
        { icon: "🧴", text: "Anti-age / Rassodamento", value: "anti-age" },
        { icon: "🌿", text: "Purificazione", value: "purificazione" },
        { icon: "☀️", text: "Luminosità / Uniformità", value: "luminosita" },
        { icon: "🩹", text: "Macchie / Discromie", value: "macchie" }
      ]
    },
    {
      title: "Per chi stai cercando?",
      subtitle: "Personalizzeremo i consigli in base alla risposta",
      type: "single",
      options: [
        { icon: "👩", text: "Per lei", value: "donna" },
        { icon: "👨", text: "Per lui", value: "uomo" },
        { icon: "👫", text: "Per entrambi", value: "entrambi" }
      ]
    }
  ];

  function renderQuiz() {
    $quizWrap.innerHTML = '';
    quizQuestions.forEach(function(q, idx) {
      var step = document.createElement('div');
      step.className = 'rb-quiz-step' + (idx === 0 ? ' active' : '');
      step.dataset.step = idx;

      var optsHtml = q.options.map(function(o) {
        return '<div class="rb-quiz-option" data-value="' + o.value + '">' +
          '<span class="rb-quiz-option-icon">' + o.icon + '</span>' +
          '<span class="rb-quiz-option-text">' + o.text + '</span>' +
          '</div>';
      }).join('');

      step.innerHTML =
        '<div class="rb-quiz-question"><h2>' + q.title + '</h2><p>' + q.subtitle + '</p></div>' +
        '<div class="rb-quiz-options">' + optsHtml + '</div>' +
        '<div class="rb-quiz-nav">' +
          (idx > 0 ? '<button class="rb-btn rb-btn-secondary rb-quiz-back">← Indietro</button>' : '') +
          '<button class="rb-btn rb-btn-primary rb-quiz-next" disabled>' + (idx === quizQuestions.length - 1 ? 'Scopri la tua routine →' : 'Avanti →') + '</button>' +
        '</div>';

      $quizWrap.appendChild(step);
    });

    $quizWrap.querySelectorAll('.rb-quiz-option').forEach(function(opt) {
      opt.addEventListener('click', onQuizOption);
    });
    $quizWrap.querySelectorAll('.rb-quiz-next').forEach(function(btn) {
      btn.addEventListener('click', onQuizNext);
    });
    $quizWrap.querySelectorAll('.rb-quiz-back').forEach(function(btn) {
      btn.addEventListener('click', onQuizBack);
    });
  }

  function onQuizOption(e) {
    var opt = e.currentTarget;
    var step = opt.closest('.rb-quiz-step');
    var qIdx = parseInt(step.dataset.step);
    var q = quizQuestions[qIdx];
    if (q.type === 'single') {
      step.querySelectorAll('.rb-quiz-option').forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
    } else {
      opt.classList.toggle('selected');
    }
    step.querySelector('.rb-quiz-next').disabled = step.querySelectorAll('.rb-quiz-option.selected').length === 0;
  }

  function onQuizNext() {
    var current = $quizWrap.querySelector('.rb-quiz-step.active');
    var qIdx = parseInt(current.dataset.step);
    var selected = current.querySelectorAll('.rb-quiz-option.selected');
    if (qIdx === 0) state.skinType = selected[0].dataset.value;
    else if (qIdx === 1) state.priorities = Array.from(selected).map(function(s) { return s.dataset.value; });
    else if (qIdx === 2) state.gender = selected[0].dataset.value;

    if (qIdx < quizQuestions.length - 1) {
      current.classList.remove('active');
      $quizWrap.querySelectorAll('.rb-quiz-step')[qIdx + 1].classList.add('active');
      scrollToTop();
    } else {
      startRoutine();
    }
  }

  function onQuizBack() {
    var current = $quizWrap.querySelector('.rb-quiz-step.active');
    var qIdx = parseInt(current.dataset.step);
    if (qIdx > 0) {
      current.classList.remove('active');
      $quizWrap.querySelectorAll('.rb-quiz-step')[qIdx - 1].classList.add('active');
    }
  }

  /* ---- FILTERING ---- */
  function getFilteredProducts(stepId) {
    return DB.filter(function(p) {
      if (p.routineStep !== stepId) return false;
      if (p.forManOnly && state.gender === 'donna') return false;
      if (p.gender === 'donna' && state.gender === 'uomo') return false;

      var skinMatch = false;
      if (state.skinType === 'tutti') {
        skinMatch = true;
      } else {
        for (var i = 0; i < p.skinTypes.length; i++) {
          if (p.skinTypes[i] === state.skinType || p.skinTypes[i] === 'tutti') { skinMatch = true; break; }
        }
      }
      if (!skinMatch) return false;

      if (['siero', 'crema-viso', 'trattamenti-speciali'].indexOf(stepId) !== -1 && state.priorities.length > 0 && p.priorities.length > 0) {
        var hasPriority = false;
        for (var j = 0; j < state.priorities.length; j++) {
          if (p.priorities.indexOf(state.priorities[j]) !== -1) { hasPriority = true; break; }
        }
        if (!hasPriority) return false;
      }
      return true;
    }).sort(function(a, b) { return getScore(b) - getScore(a); });
  }

  function getScore(p) {
    var s = 0;
    if (p.skinTypes.indexOf(state.skinType) !== -1) s += 3;
    state.priorities.forEach(function(pr) { if (p.priorities.indexOf(pr) !== -1) s += 2; });
    if (state.gender === 'uomo' && p.forManOnly) s += 2;
    return s;
  }

  function getActiveSteps() {
    return STEPS.filter(function(step) {
      if (step.id === 'post-rasatura' && state.gender === 'donna') return false;
      return getFilteredProducts(step.id).length > 0;
    });
  }

  /* ---- ROUTINE FLOW ---- */
  function startRoutine() {
    state.phase = 'routine';
    state.currentStep = 0;
    $quizWrap.style.display = 'none';
    $tabs.style.display = '';
    $stepFooter.style.display = '';

    renderTabs();
    renderCurrentStep();
    updateStickyCheckout();
    scrollToTop();
  }

  function renderTabs() {
    var steps = getActiveSteps();
    $tabs.innerHTML = '';
    steps.forEach(function(step, idx) {
      var tab = document.createElement('button');
      tab.className = 'rb-step-tab' + (idx === state.currentStep ? ' active' : '');
      tab.dataset.idx = idx;

      var stepProducts = DB.filter(function(p) { return p.routineStep === step.id; });
      var hasAdded = stepProducts.some(function(p) { return state.addedHandles.indexOf(p.handle) !== -1; });
      if (hasAdded) tab.classList.add('has-items');

      tab.innerHTML = step.emoji + ' ' + step.label;
      tab.addEventListener('click', function() {
        state.currentStep = parseInt(this.dataset.idx);
        renderTabs();
        renderCurrentStep();
        scrollToTop();
      });
      $tabs.appendChild(tab);
    });
  }

  var stepDescriptions = {
    'detersione': 'La detersione è il primo passo fondamentale della tua skincare. Rimuove trucco, sebo e impurità accumulate durante la giornata, preparando la pelle a ricevere al meglio i trattamenti successivi. Una pelle pulita assorbe meglio ogni principio attivo.',
    'tonico': 'Il tonico completa la detersione e riequilibra il pH naturale della pelle. Minimizza i pori, tonifica e prepara l\'epidermide ad assorbire in profondità i principi attivi dei sieri e delle creme che applicherai subito dopo.',
    'siero': 'I sieri contengono la più alta concentrazione di principi attivi e penetrano in profondità nell\'epidermide. Lavorano sulle esigenze specifiche della tua pelle: idratazione, anti-age, luminosità o purificazione. Sono il vero motore dei risultati visibili.',
    'crema-viso': 'La crema viso sigilla l\'idratazione e crea una barriera protettiva sulla pelle. Nutre in profondità, protegge dagli agenti esterni e mantiene la pelle morbida e luminosa per tutta la giornata.',
    'trattamenti-speciali': 'Trattamenti mirati per esigenze specifiche: esfoliazione per rinnovare la pelle, maschere purificanti per una pulizia profonda, creme notte per una rigenerazione intensiva. Da usare 1-2 volte a settimana per risultati visibili.',
    'corpo': 'Prenditi cura anche della pelle del corpo. Idratazione, nutrimento e protezione per una pelle luminosa, elastica e morbida dalla testa ai piedi. Le zone come mani, braccia e décolleté meritano un\'attenzione speciale.',
    'post-rasatura': 'Dopo la rasatura la pelle ha bisogno di cure specifiche. Prodotti lenitivi che calmano le irritazioni, idratano in profondità e proteggono la pelle appena rasata. Essenziali per comfort immediato e prolungato.',
    'capelli': 'Trattamenti specifici per il cuoio capelluto e la vitalità dei capelli. Dalla detersione delicata ai sieri anticaduta, fino allo styling: tutto ciò che serve per capelli forti, sani e belli ogni giorno.'
  };

  function renderCurrentStep() {
    var steps = getActiveSteps();
    var stepDef = steps[state.currentStep];
    var products = getFilteredProducts(stepDef.id);
    var isLast = state.currentStep === steps.length - 1;

    $stepsWrap.innerHTML = '';
    var el = document.createElement('div');
    el.className = 'rb-step active';

    var desc = stepDescriptions[stepDef.id] || stepDef.desc;

    el.innerHTML =
      '<div class="rb-step-header">' +
        '<h2>' + stepDef.emoji + ' ' + stepDef.label + '</h2>' +
        '<p>' + desc + '</p>' +
      '</div>' +
      '<div class="rb-products" id="rb-products-grid"></div>';

    $stepsWrap.appendChild(el);

    var grid = el.querySelector('#rb-products-grid');
    if (products.length === 0) {
      grid.innerHTML = '<div class="rb-no-products"><p>Nessun prodotto disponibile per questo step con le tue preferenze.</p></div>';
    } else {
      products.forEach(function(p) {
        var isAdded = state.addedHandles.indexOf(p.handle) !== -1;
        var card = document.createElement('div');
        card.className = 'rb-product-card' + (isAdded ? ' in-cart' : '');
        card.innerHTML =
          '<div class="rb-product-img"><img src="' + p.image + '" alt="' + p.name + '" loading="lazy"></div>' +
          '<div class="rb-product-info">' +
            '<span class="rb-product-brand">' + p.brand + '</span>' +
            '<span class="rb-product-name">' + p.name + '</span>' +
            '<span class="rb-product-benefit">' + p.benefit + '</span>' +
            '<div class="rb-product-bottom">' +
              '<span class="rb-product-price">€' + p.price.toFixed(2) + '</span>' +
              '<button class="rb-product-add" data-handle="' + p.handle + '">' + (isAdded ? '✕ Rimuovi' : '+ Aggiungi al carrello') + '</button>' +
            '</div>' +
          '</div>';
        grid.appendChild(card);

        card.querySelector('.rb-product-add').addEventListener('click', function(e) {
          onAddToCart(e.currentTarget.dataset.handle, e.currentTarget);
        });
      });
    }

    // Step footer
    $stepFooter.innerHTML = '';
    if (state.currentStep > 0) {
      var backBtn = document.createElement('button');
      backBtn.className = 'rb-btn rb-btn-secondary';
      backBtn.textContent = '← Indietro';
      backBtn.addEventListener('click', function() {
        state.currentStep--;
        renderTabs();
        renderCurrentStep();
        scrollToTop();
      });
      $stepFooter.appendChild(backBtn);
    }

    if (!isLast) {
      var nextBtn = document.createElement('button');
      nextBtn.className = 'rb-btn rb-btn-primary';
      nextBtn.textContent = 'Avanti →';
      nextBtn.addEventListener('click', function() {
        state.currentStep++;
        renderTabs();
        renderCurrentStep();
        scrollToTop();
      });
      $stepFooter.appendChild(nextBtn);
    }
  }

  /* ---- STICKY CHECKOUT ---- */
  function updateStickyCheckout() {
    if (!$stickyCheckout) return;
    var count = state.addedHandles.length;
    if (count > 0) {
      $stickyCheckout.classList.add('visible');
      var info = $stickyCheckout.querySelector('.rb-sticky-checkout-info');
      if (info) {
        info.innerHTML = '<strong>' + count + ' prodott' + (count === 1 ? 'o' : 'i') + '</strong> nel carrello';
      }
    } else {
      $stickyCheckout.classList.remove('visible');
    }
  }

  /* ---- DIRECT ADD TO CART + CART DRAWER ---- */
  function onAddToCart(handle, btnEl) {
    var variantId = state.variantMap[handle];
    if (!variantId) {
      alert('Prodotto non ancora caricato. Riprova tra un momento.');
      return;
    }

    var isAdded = state.addedHandles.indexOf(handle) !== -1;
    btnEl.disabled = true;
    btnEl.innerHTML = '<span class="rb-loading"><span class="rb-loading-dot"></span><span class="rb-loading-dot"></span><span class="rb-loading-dot"></span></span>';

    if (isAdded) {
      // Remove from cart
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.toString(), quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(cartData) {
        state.addedHandles = state.addedHandles.filter(function(h) { return h !== handle; });
        renderTabs();
        renderCurrentStep();
        updateStickyCheckout();
        refreshCartUI(cartData);
      })
      .catch(function() {
        btnEl.disabled = false;
        btnEl.textContent = '✕ Rimuovi';
      });
    } else {
      // Add to cart silently (no drawer)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        state.addedHandles.push(handle);
        renderTabs();
        renderCurrentStep();
        updateStickyCheckout();
        // Update SPB and cart icon
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cartData) {
        refreshCartUI(cartData);
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        btnEl.disabled = false;
        btnEl.textContent = '+ Aggiungi al carrello';
      });
    }
  }

  function refreshCartUI(cartData) {
    // Update SPB
    if (window.publish && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.publish(PUB_SUB_EVENTS.cartUpdate, { cartData: cartData });
    }
    // Silently refresh cart drawer HTML + cart icon bubble (without opening drawer)
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        // Update cart icon bubble
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
        // Silently update cart drawer content (so it shows items when opened manually)
        var drawerEl = document.getElementById('CartDrawer');
        if (drawerEl && sections['cart-drawer']) {
          var newDrawerHTML = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('#CartDrawer');
          if (newDrawerHTML) {
            drawerEl.innerHTML = newDrawerHTML.innerHTML;
            // Re-attach overlay close listener
            var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
            var cartDrawerComponent = document.querySelector('cart-drawer');
            if (overlay && cartDrawerComponent) {
              overlay.addEventListener('click', cartDrawerComponent.close.bind(cartDrawerComponent));
            }
            // Remove 'is-empty' class if cart has items
            var innerEl = drawerEl.closest('.drawer__inner') || drawerEl.parentElement;
            if (innerEl && cartData && cartData.item_count > 0) {
              innerEl.classList.remove('is-empty');
            }
          }
        }
      }).catch(function() {});
  }

  // Hide sticky checkout when cart drawer is open
  function watchCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl || !$stickyCheckout) return;

    var observer = new MutationObserver(function() {
      if (cartDrawerEl.classList.contains('active')) {
        $stickyCheckout.style.display = 'none';
      } else {
        $stickyCheckout.style.display = '';
      }
    });
    observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
})();

